export { FontIcon } from './FontIcon';
